import React from 'react';
import { Popover, PopoverProps } from 'react-aria-components';

import classNames from 'classnames';
import styles from './Menu.module.scss';

interface Props extends PopoverProps {
  children: React.ReactNode;
  className?: string;
}

export const MenuPopover = ({ children, className, ...rest }: Props) => {
  const classes = classNames(styles.MenuPopover, className);
  return (
    <Popover className={classes} {...rest}>
      {children}
    </Popover>
  );
};

export default MenuPopover;
